import { render, staticRenderFns } from "./cdmfeedback.vue?vue&type=template&id=5a12c794&"
import script from "./cdmfeedback.vue?vue&type=script&lang=js&"
export * from "./cdmfeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports